import { v4 as uuidv4 } from "uuid";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IThuPhiTamThuTab } from "../../../model/request/thu-phi-tam-thu/IThuPhiTamThu";
import { IThuPhiTamThuReducer } from "../../reducer-model/thu-phi-tam-thu/IThuPhiTamThuReducer";
import { IThuPhiTamThuActionTypes } from "../../action-types/thu-phi-tam-thu/IThuPhiTamThuActionTypes";
import { IMucThuTamThuSinhVienViewModel } from "../../../model/respone/chung-tu-tam-thu/IMucThuTamThuSinhVienViewModel";
const iniTab: IThuPhiTamThuTab = {
  id: uuidv4(),
  title: "Untitled",
  mucThuTamThus: [],
  mucThuTamThuSelectedIds: [],
  step: 0,
  hinhThucNops: [],
  status: eReducerStatusBase.is_not_initialization,
  thongTinBienLai: {
    bienLaiId: 0,
    bienLaiPhieuThu: "",
    bienLaiTempPhieuThu: "",
    loaiBienLai: "thu",
    chiTuBienLaiId: 0,
  },
};
const iniState: IThuPhiTamThuReducer = {
  selectedId: iniTab.id,
  tabs: [iniTab],
};
export const thuPhiTamThuReducer = (
  state: IThuPhiTamThuReducer = iniState,
  action: IThuPhiTamThuActionTypes
): IThuPhiTamThuReducer => {
  switch (action.type) {
    case "THU_PHI_TAM_THU_ADD_NEW_TAB":
      let exist = state.tabs.find(
        (g) =>
          g.sinhVien?.id_sv === action.payload?.id_sv &&
          g.thongTinBienLai.bienLaiId <= 0
      );
      const id = exist?.id ?? uuidv4();
      return {
        ...state,
        selectedId: id,
        tabs: exist
          ? [...state.tabs]
          : [
              {
                ...iniTab,
                title: action.payload?.ho_ten ?? "Untitled",
                id: id,
                sinhVien: action.payload,
              },
              ...state.tabs,
            ],
      };
    case "THU_PHI_TAM_THU_REMOVE_TAB":
      return {
        ...state,
        tabs: state.tabs.filter((t) => t.id !== action.payload),
      };
    case "THU_PHI_TAM_THU_UPDATE_TAB_DATA":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return action.payload;
          }
          return t;
        }),
      };
    case "THU_PHI_TAM_THU_CHANGEG_SELECTED_TAB":
      return {
        ...state,
        selectedId: action.payload,
      };
    case "THU_PHI_TAM_THU_LOAD_MUC_THU_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_loading,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TAM_THU_LOAD_MUC_THU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              mucThuTamThus: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TAM_THU_LOAD_MUC_THU_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              mucThuTamThus: [],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TAM_THU_CHANGE_MUC_THU_SELECTED_IDs":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: [],
              mucThuTamThuSelectedIds: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TAM_THU_CHANGE_STEP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              step: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TAM_THU_CHANGE_HINHTHUCNOP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TAM_THU_CREATE_BIENLAITHU_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_saving,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TAM_THU_CREATE_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_need_reload,
              //status: eReducerStatusBase.is_completed,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiId: action.payload.data,
              },
              step: 2,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TAM_THU_CREATE_BIENLAITHU_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              bienLaiId: 0,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TAM_THU_CHANGE_SO_TIEN_THUC_NOP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: [],
              mucThuTamThuSelectedIds: [
                ...t.mucThuTamThuSelectedIds.filter(
                  (g) => g !== (action.payload.request?.id_thu_chi ?? 0)
                ),
                action.payload.data > 0
                  ? action.payload.request?.id_thu_chi ?? 0
                  : 0,
              ],
              mucThuTamThus: [
                ...t.mucThuTamThus.map(
                  (mtk: IMucThuTamThuSinhVienViewModel) => {
                    if (mtk.id_thu_chi === action.payload.request.id_thu_chi) {
                      return {
                        ...mtk,
                        so_tien_thuc_nop: action.payload.data,
                      };
                    }
                    return mtk;
                  }
                ),
              ],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_TAM_THU_CHANGE_THONGTINBIENLAI":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            let obj = {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                ...action.payload.data,
              },
            };
            if ("loaiBienLai" in action.payload.data) {
              obj = {
                ...obj,
                mucThuTamThus: [],
                mucThuTamThuSelectedIds: [],
                hinhThucNops: [],
                step: 0,
                status: eReducerStatusBase.is_need_reload,
              };
            }
            return obj;
          }
          return t;
        }),
      };
    default:
      return state;
  }
};
